import { render, staticRenderFns } from "./ProjectConfiguration.vue?vue&type=template&id=1357c09e&scoped=true"
import script from "./ProjectConfiguration.vue?vue&type=script&lang=js"
export * from "./ProjectConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ProjectConfiguration.vue?vue&type=style&index=0&id=1357c09e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1357c09e",
  null
  
)

export default component.exports